// extracted by mini-css-extract-plugin
export default {"dark":"popup_dark__71oPO","marginRight":"popup_marginRight__cRwaB"};